<template>
  <div @click.stop="hideImg" v-if="showBox" class="big-img-box">
      <div class="center-big-img" @click.stop="openVideo">
          <!-- //../../../assets/img/Usehelp-English/7-DE-InsertRemarkLink-web.mp4 -->
        <video :src="videoUrl" style="" class="center-big-video-url" 
        controls autoplay="autoplay" :poster="imgUrl" >
        </video>
      </div>
      <!-- <img class="center-big-img" :style="{backgroundUrl:''}" :src="imgUrl" alt=""> -->
  </div>
</template>

<script>
import HttpServerConfig from '../../../common/HttpServerConfig';
import { md5 } from '../../../common/netWork/base';
import StorageManager from '../../../core/core/storage/StorageManager';
import Util from '../../../utils/Util';
import LoadLocalXJMind from '../../../viewmodel/core/tools/mapfile/LoadLocalXJMind';
import MindMapZipConstant from '../../../viewmodel/core/tools/mapfile/MindMapZipConstant';
export default {
    data() {
        return {
            showBox: false,
            imgUrl: "",
            videoUrl: "",
            backgroundSize: 'contain'
        }
    },
    created() {
        this.bus.$on("examineVideoImg", (msg) => {
            // console.log(msg);
            this.showBox = true;
            let storageManager = new StorageManager()
            if (msg.src != null && msg.src.indexOf("xjcache") > -1) {
                this.imgUrl = storageManager.getFileLoadPath(msg.src)
            } else {
                this.imgUrl = LoadLocalXJMind.getLocalFilePath(HttpServerConfig.getMediaSrc(msg.src))
            }            
            if (msg.videoSrc != null && msg.videoSrc.indexOf("xjcache") > -1) {                
                this.videoUrl = storageManager.getFileLoadPath(msg.videoSrc)
            } else {
                this.videoUrl = LoadLocalXJMind.getLocalFilePath(HttpServerConfig.getMediaSrc(msg.videoSrc))
            }
        });
    },
    methods: {
        hideImg () {
            this.showBox = false;
        },
        openVideo(){
            this.showBox = true; 
        }
    }
}
</script>

<style lang="less" scoped>
    .big-img-box {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99999;
        background-color: rgba(0, 0, 0, 0.5);

        .center-big-img {
            position: absolute;
            background-position: center center;
            background-repeat:no-repeat;
            // background-size: contain;

            /* 允许用户调整大小 */
            resize: both;
            overflow: auto;
            
            max-width: 90%;
            max-height: 100%;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
        @media screen and(max-width:800px) {
            .center-big-img {
                position: absolute;
                background-position: center center;
                background-repeat:no-repeat;
                // background-size: contain;
                /* 允许用户调整大小 */
                resize: both;
                overflow: auto;
                
                width: 100%;
                max-height: 90%;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
            .center-big-video-url{
                max-width:100%;
                max-height: 100%;
                object-fit: contain;
                border: 2px solid #1a1a1a;
                border-radius: 20px;
                background: #1a1a1a;
            }
        }
        @media screen and(min-width:801px){
            .center-big-video-url{
                max-height:100%;
                max-width: 100%;
                object-fit: contain;

                border: 2px solid #1a1a1a;
                border-radius: 20px;
                background: #1a1a1a;
            }
        }
    }
</style>